// extracted by mini-css-extract-plugin
export default {"wrapper":"K2-z","play":"L2-z"};